import { FileDetailsDTO } from '../../../api/plyca-dtos';

export function isFilePdf(file: FileDetailsDTO | null): boolean {
  if (file) {
    let name: string = file.name || '';
    return name.toUpperCase().substring(name.lastIndexOf('.') + 1) === 'PDF';
  }
  return false;
}

export function checkFileSize(file: FileDetailsDTO, maxFileSizeMB: number): boolean {
  return file.size > maxFileSizeMB * 1024;
}